import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "filter-newsroom-event__title" };
const _hoisted_2 = ["aria-expanded"];
const _hoisted_3 = { class: "filter-newsroom-event__zone-title-text" };
const _hoisted_4 = ["role"];
const _hoisted_5 = { class: "filter-newsroom-event__zonecontent-scroll" };
const _hoisted_6 = { class: "filter-newsroom-event__formfields" };
const _hoisted_7 = { class: "form__fieldset filter-newsroom-event__date" };
const _hoisted_8 = { class: "form__row filter-newsroom-event__datearea" };
const _hoisted_9 = { class: "form__col" };
const _hoisted_10 = ["data-js-lng", "data-js-past-years", "data-js-next-years"];
const _hoisted_11 = { class: "form__datepicker-inputarea" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", {
    class: "form__datepicker-container",
    "data-js-item": "js-form-datepicker-container"
}, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", {
    class: "form__datepicker-container",
    "data-js-item": "js-form-datepicker-container"
}, null, -1 /* HOISTED */);
const _hoisted_14 = { class: "filter-newsroom-event__buttonarea" };
import { ref } from "vue";
import { generateStartEndDate } from "../services/date-mapper";
import { useClickOutside, useI18n, useNewsFilter, useConfig } from "../features";
import DateFilterButton from "./DateFilterButton.vue";
import DateFilterInput from "./DateFilterInput.vue";
const ARCHIVE_FALLBACK_YEARS = 10; // in case pastYears in archive mode null.
const ARCHIVE_START_YEAR = 0; // 0= Today, -1=Yesterday, >0 add years to pickaday
export default /*#__PURE__*/ _defineComponent({
    __name: 'DateFilter',
    props: {
        enable: { type: Boolean }
    },
    setup(__props) {
        const { enable } = __props;
        const { pastYears, thema, archive } = useConfig();
        const { t, getLocale, getLanguage } = useI18n();
        const { dateRange, applyFilters, dateFilterInputs } = useNewsFilter();
        const isOpen = ref(false);
        const isValid = ref(true);
        const locale = getLocale();
        const lng = getLanguage();
        const buttons = ref([
            { id: "fl_fb_2_1", title: t('timeItems_buttons_7_title'), period: 7 },
            { id: "fl_fb_2_2", title: t('timeItems_buttons_30_title'), period: 30 }
        ]);
        const toggleDatePicker = () => {
            isOpen.value = !isOpen.value;
        };
        const { elementRef } = useClickOutside(isOpen, toggleDatePicker);
        const updatePeriod = (period) => {
            if (!period) {
                throw Error(`Period is not defined`);
            }
            const { startDate, endDate } = generateStartEndDate(period, locale);
            dateFilterInputs.value[0].value = startDate;
            dateFilterInputs.value[1].value = endDate;
        };
        const updateText = (index, value) => {
            console.log(`Index ${index} Value ${value}`);
            if (dateFilterInputs.value) {
                dateFilterInputs.value[index].value = value;
            }
        };
        const submitSelection = () => {
            if (!dateFilterInputs.value) {
                isValid.value = false;
                return;
            }
            if (dateFilterInputs.value.findIndex(item => item.value === '') > 0) {
                isValid.value = false;
                return;
            }
            isValid.value = true;
            dateRange.value = [];
            dateFilterInputs.value.map(input => {
                dateRange.value?.push(input.value);
            });
            applyFilters(lng);
            isOpen.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "elementRef",
                ref: elementRef,
                class: _normalizeClass(["filter-newsroom-event__filter", _ctx.enable ? '' : 'is-hidden'])
            }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('filter_time_title')), 1 /* TEXT */),
                _createElementVNode("div", {
                    class: _normalizeClass(["filter-newsroom-event__zone", isOpen.value ? 'is-showFilter' : 'is-hideFilter'])
                }, [
                    _createElementVNode("button", {
                        onClick: toggleDatePicker,
                        class: "filter-newsroom-event__zone-title",
                        "aria-haspopup": "true",
                        "aria-expanded": isOpen.value,
                        type: "button"
                    }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('filter_time_choose')), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_2),
                    _createElementVNode("div", {
                        class: "filter-newsroom-event__zonecontent",
                        role: _unref(t)('filter_time_dropdown_placeholder').toString()
                    }, [
                        _createElementVNode("div", _hoisted_5, [
                            (_unref(thema) === 'events' && !_unref(archive))
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(buttons.value, (item) => {
                                    return (_openBlock(), _createBlock(DateFilterButton, {
                                        key: item.id,
                                        item: item,
                                        "onUpdate:period": updatePeriod
                                    }, null, 8 /* PROPS */, ["item"]));
                                }), 128 /* KEYED_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("fieldset", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", {
                                                class: "form__datepicker",
                                                "data-js-module": "form-datepicker",
                                                "data-js-lng": _unref(lng),
                                                "data-js-past-years": _unref(pastYears) ? _unref(pastYears) : _unref(archive) ? ARCHIVE_FALLBACK_YEARS : _unref(pastYears),
                                                "data-js-next-years": _unref(archive) ? ARCHIVE_START_YEAR : null,
                                                "data-js-item": "js-form-datepicker-area"
                                            }, [
                                                _createElementVNode("div", _hoisted_11, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dateFilterInputs), (item, index) => {
                                                        return (_openBlock(), _createBlock(DateFilterInput, {
                                                            key: item.id,
                                                            item: item,
                                                            "onUpdate:text": ($event) => (updateText(index, $event))
                                                        }, null, 8 /* PROPS */, ["item", "onUpdate:text"]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]),
                                                _hoisted_12,
                                                _hoisted_13
                                            ], 8 /* PROPS */, _hoisted_10)
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", {
                                class: _normalizeClass(["filter-newsroom-event__errortext", isValid.value ? 'is-hideFilter' : 'is-showFilter'])
                            }, _toDisplayString(_unref(t)('filter_time_errordate')), 3 /* TEXT, CLASS */)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                                onClick: submitSelection,
                                type: "button",
                                class: "filter-newsroom-event__submitbutton"
                            }, _toDisplayString(_unref(t)('filter_time_button')), 1 /* TEXT */)
                        ])
                    ], 8 /* PROPS */, _hoisted_4)
                ], 2 /* CLASS */)
            ], 2 /* CLASS */));
        };
    }
});
